<template lang="pug">
  .popularGiftsSlide.grey-background(ref="popularGifts")
    h4.black What are the most popular holiday gifts?<span class="super"><a href="https://www.slideshare.net/NationalRetailFederation/holiday-2018-consumer-trends" target="_blank">2</a></span>
    IconChart(:items="IconChart")
</template>

<script>
import IconChart from './IconChart'

export default {
  name: 'popularGiftsSlide',
  props: {
  },
  data () {
    return {
      IconChart: [
        {
          icon: 'IconClothing',
          number: 59,
          copy: 'Clothing/Accessories',
        },
        {
          icon: 'IconElectronics',
          number: 26,
          copy: 'Consumer Electronics',
        },
        {
          icon: 'IconGiftCards',
          number: 56,
          copy: 'Gift Cards',
        },
        {
          icon: 'IconPersonalCare',
          number: 25,
          copy: 'Personal Care',
        },
        {
          icon: 'IconToys',
          number: 41,
          copy: 'Toys',
        },
        {
          icon: 'IconDecor',
          number: 21,
          copy: 'Home D&#233;cor',
        },
        {
          icon: 'IconBooks',
          number: 40,
          copy: 'Books/Other Media',
        },
        {
          icon: 'IconCash',
          number: 21,
          copy: 'Cash',
        },
        {
          icon: 'IconFood',
          number: 32,
          copy: 'Food/Candy',
        },
        {
          icon: 'IconJewelry',
          number: 20,
          copy: 'Jewelry',
        },
      ]
    }
  },
  mounted () {
  },
  computed: {
  },
  methods: {
    playAnimation () {
      console.log('play popularGifts slide ani')
    },
  },
  components: {
    IconChart,
  },
}
</script>

<style scoped lang="scss">
.popularGiftsSlide {
  height: 78rem;
  padding-top: 5rem;
  h4 {
    text-align: center;
    padding-bottom: 2rem;
  }
  h3 {
    color: black;
  }
}
</style>
